import { combineReducers } from 'redux';

import auth from './auth';
import tabs from './tabs';
import navi from './navi';
import dbinfo from './dbinfo';
import profile from './profile';
import cart from './cart';
import client from './client';
import password from './password';
import messages from './messages';
import calendar from './calendar';
import {reducer as modals} from 'reactis-modal';
import {reducer as datagrids} from './datagridTab';
import {reducer as forms} from './formTab';

export default combineReducers({
	auth,
	navi,
	forms,
	datagrids,
	tabs,
	modals,
	profile,
	dbinfo,
	password,
	cart,
    client,
	calendar,
	messages
});




// WEBPACK FOOTER //
// ./src/redux/modules/reducer.js